<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card class="justify-center" color="black" dark>
        <div class="logo-img"></div>
        <div class="container-notification">
          <img class="align-center" src="/logo-mikro.png" alt="">
          <v-flex xs10 offset-xs1 sm8 offset-sm2 md6 offset-md3 class="text-xs-center">
            <h1>Mejora la experiencia con la app de Microcanales</h1>
          </v-flex>
          <v-btn
            class="align-center-btn"
            width="340px"
            color="primary"
            @click="go(true); dialog = false;">Obtener la app</v-btn>
          <!-- <v-btn class="align-center-btn" width="340px"
            @click="go(); dialog = false;">Continuar</v-btn> -->
        </div>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  export default {
    data: () => ({
      dialog: true
    }),
    computed: {
      ...mapGetters(['user'])
    },
    methods: {
      ...mapActions(['updateUserPrivacy']),
      go(goApp) {
        if (goApp) {
          if (window.ios) {
            location.href = 'https://apps.apple.com/es/app/microcanales/id1373292896'
          } else {
            location.href = 'https://play.google.com/store/apps/details?id=com.amcnetworks.microcanales'
          }
        } else {
          this.$router.push({name: 'Home'})
        }
      }
    }
  }
</script>

<style scoped>
  .align-center {
    margin-top: 10%;
    margin-left: calc(50% - 165px);
  }
  .align-center-btn {
    display: block;
    margin-left: calc(50% - 136px);
  }
  .button-appstore {
    width: 150px;
    margin: auto 10px;
  }
</style>
<style>
  .align-center-btn * {
    width: 240px;
  }
</style>